import MethodOrder from './MethodOrder.vue'

export default MethodOrder
